<template>
  <div class="pagina ativa" id="paginaInicio">
    <div class="pagina-titulo" style="display:flex;align-items:center;gap:9px;"><Home :size="20" /> Inicio</div>
    <div class="inicio-grid" style="display:grid;grid-template-columns:1fr 340px;gap:20px;min-width:0;">
      <div style="background:white;border-radius:10px;padding:20px;box-shadow:0 2px 8px rgba(0,0,0,0.08);min-width:0;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:15px;">
          <button @click="mudarMes(-1)" style="padding:6px 14px;font-size:16px;margin-top:0;">‹</button>
          <span style="font-weight:bold;font-size:16px;color:#4a5c2f;">{{ tituloMes }}</span>
          <button @click="mudarMes(1)" style="padding:6px 14px;font-size:16px;margin-top:0;">›</button>
        </div>
        <div style="display:grid;grid-template-columns:repeat(7,minmax(0,1fr));gap:4px;margin-bottom:8px;">
          <div v-for="d in ['Dom','Seg','Ter','Qua','Qui','Sex','Sab']" :key="d" style="text-align:center;font-size:12px;font-weight:bold;color:#888;">{{ d }}</div>
        </div>
        <div style="display:grid;grid-template-columns:repeat(7,minmax(0,1fr));gap:4px;">
          <div v-for="(dia, idx) in diasGrade" :key="idx"
               @click="dia && selecionarDia(dia)"
               :style="estiloDia(dia)">
            {{ dia ? dia.getDate() : '' }}
          </div>
        </div>
      </div>
      <div style="background:white;border-radius:10px;padding:20px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:15px;">
          <span style="font-weight:bold;color:#4a5c2f;font-size:15px;">{{ diaSelecionado ? tituloDia : 'Selecione um dia' }}</span>
          <button v-if="diaSelecionado" @click="abrirModalCompromisso()" style="padding:6px 12px;font-size:13px;margin-top:0;">+ Novo</button>
        </div>
        <div style="max-height:400px;overflow-y:auto;">
          <p v-if="!diaSelecionado" style="color:#aaa;text-align:center;">Clique em um dia do calendario.</p>
          <p v-else-if="compromissosDoDia.length === 0" style="color:#aaa;text-align:center;">Nenhum compromisso neste dia.</p>
          <div v-for="c in compromissosDoDia" :key="c.id" style="border-left:4px solid;padding:8px 10px;margin-bottom:8px;background:#f8f9f6;border-radius:6px;" :style="{ borderColor: c.cor || '#4a5c2f' }">
            <div style="display:flex;justify-content:space-between;">
              <strong style="font-size:13px;">{{ c.hora }}{{ c.horaFim ? ' - ' + c.horaFim : '' }} — {{ c.titulo }}</strong>
              <span style="display:inline-flex;cursor:pointer;color:#c0392b;" @click="excluirCompromisso(c.id)"><X :size="13" /></span>
            </div>
            <div v-if="c.descricao" style="font-size:12px;color:#666;margin-top:4px;">{{ c.descricao }}</div>
          </div>
        </div>
      </div>
    </div>

    <div style="background:white;border-radius:10px;padding:20px;box-shadow:0 2px 8px rgba(0,0,0,0.08);margin-top:20px;">
      <div style="font-weight:bold;color:#4a5c2f;font-size:15px;margin-bottom:15px;">Observacoes</div>
      <div style="display:flex;gap:10px;margin-bottom:15px;">
        <textarea v-model="novaObservacao" placeholder="Digite uma observacao..." style="flex:1;padding:10px;border:1px solid #ccc;border-radius:5px;font-size:14px;height:60px;resize:vertical;"></textarea>
        <button @click="salvarObservacao" style="margin-top:0;padding:10px 20px;align-self:flex-start;">Salvar</button>
      </div>
      <div v-for="o in observacoes" :key="o.id" style="padding:10px;border-bottom:1px solid #eee;font-size:13px;">
        <div style="color:#888;font-size:11px;margin-bottom:3px;">{{ o.data }}</div>
        <div>{{ o.texto }}</div>
      </div>
    </div>

    <div v-if="modalAberto" class="app-drawer-overlay">
      <div class="app-drawer">
        <h3>Novo Compromisso</h3>
        <label>Titulo</label>
        <input type="text" v-model="novoCompromisso.titulo" />
        <label>Hora inicio</label>
        <input type="text" v-model="novoCompromisso.hora" placeholder="HH:MM" />
        <label>Hora fim (opcional)</label>
        <input type="text" v-model="novoCompromisso.horaFim" placeholder="HH:MM" />
        <label>Descricao</label>
        <input type="text" v-model="novoCompromisso.descricao" />
        <div class="app-drawer-acoes">
          <button @click="modalAberto = false" style="background:#888;">Cancelar</button>
          <button @click="salvarCompromisso">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPost, apiDelete, getSession } from '../api'
import { Home, X } from 'lucide-vue-next'

export default {
  components: { Home, X },
  name: 'PaginaInicio',
  data() {
    return {
      mesAtual: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      diaSelecionado: null,
      compromissos: [],
      observacoes: [],
      novaObservacao: '',
      modalAberto: false,
      novoCompromisso: { titulo: '', hora: '', horaFim: '', descricao: '' }
    }
  },
  computed: {
    tituloMes() {
      const meses = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro']
      return meses[this.mesAtual.getMonth()] + ' ' + this.mesAtual.getFullYear()
    },
    tituloDia() {
      if (!this.diaSelecionado) return ''
      return this.diaSelecionado.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
    },
    diasGrade() {
      const ano = this.mesAtual.getFullYear()
      const mes = this.mesAtual.getMonth()
      const primeiroDiaSemana = new Date(ano, mes, 1).getDay()
      const totalDias = new Date(ano, mes + 1, 0).getDate()
      const grade = []
      for (let i = 0; i < primeiroDiaSemana; i++) grade.push(null)
      for (let d = 1; d <= totalDias; d++) grade.push(new Date(ano, mes, d))
      return grade
    },
    compromissosDoDia() {
      if (!this.diaSelecionado) return []
      const iso = this.formatarISO(this.diaSelecionado)
      return this.compromissos.filter(c => c.data === iso).sort((a, b) => (a.hora || '').localeCompare(b.hora || ''))
    }
  },
  created() {
    this.carregarCompromissos()
    this.carregarObservacoes()
  },
  methods: {
    formatarISO(d) {
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0')
    },
    estiloDia(dia) {
      if (!dia) return {}
      const iso = this.formatarISO(dia)
      const temCompromisso = this.compromissos.some(c => c.data === iso)
      const isHoje = iso === this.formatarISO(new Date())
      const isSelecionado = this.diaSelecionado && iso === this.formatarISO(this.diaSelecionado)
      return {
        textAlign: 'center', padding: '8px 0', cursor: 'pointer', borderRadius: '6px', fontSize: '13px',
        background: isSelecionado ? '#4a5c2f' : (isHoje ? '#e8f0e8' : 'transparent'),
        color: isSelecionado ? 'white' : (isHoje ? '#4a5c2f' : '#333'),
        fontWeight: temCompromisso ? 'bold' : 'normal',
        border: temCompromisso && !isSelecionado ? '1.5px solid #4a5c2f' : '1.5px solid transparent'
      }
    },
    mudarMes(delta) {
      this.mesAtual = new Date(this.mesAtual.getFullYear(), this.mesAtual.getMonth() + delta, 1)
    },
    selecionarDia(dia) {
      this.diaSelecionado = dia
    },
    async carregarCompromissos() {
      const s = getSession()
      const r = await apiGet('compromissos/listar', { usuario: s.nome })
      if (r.sucesso) this.compromissos = r.compromissos
    },
    async carregarObservacoes() {
      const s = getSession()
      const r = await apiGet('observacoes/listar', { usuario: s.nome })
      if (r.sucesso) this.observacoes = r.observacoes
    },
    async salvarObservacao() {
      if (!this.novaObservacao.trim()) return
      const s = getSession()
      const r = await apiPost('observacoes/salvar', { usuario: s.nome, texto: this.novaObservacao.trim() })
      if (r.sucesso) {
        this.novaObservacao = ''
        this.carregarObservacoes()
      }
    },
    abrirModalCompromisso() {
      this.novoCompromisso = { titulo: '', hora: '', horaFim: '', descricao: '' }
      this.modalAberto = true
    },
    async salvarCompromisso() {
      if (!this.novoCompromisso.titulo || !this.novoCompromisso.hora) return
      const s = getSession()
      const r = await apiPost('compromissos/salvar', {
        usuario: s.nome,
        data: this.formatarISO(this.diaSelecionado),
        hora: this.novoCompromisso.hora,
        horaFim: this.novoCompromisso.horaFim,
        titulo: this.novoCompromisso.titulo,
        descricao: this.novoCompromisso.descricao,
        cor: '#4a5c2f'
      })
      if (r.sucesso) {
        this.modalAberto = false
        this.carregarCompromissos()
      }
    },
    async excluirCompromisso(id) {
      const r = await apiDelete('compromissos/excluir', { id })
      if (r.sucesso) this.carregarCompromissos()
    }
  }
}
</script>
